var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17278",
    "data-name": "Groupe 17278",
    transform: "translate(-901 -964)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5351",
    "data-name": "Rectangle 5351",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(901 964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-medium",
    "data-name": "Icon awesome-medium",
    d: "M0,2.25v16H16v-16ZM13.293,6.039l-.857.821a.252.252,0,0,0-.1.239v6.047a.246.246,0,0,0,.1.239l.839.821v.182H9.061v-.175l.868-.843c.086-.086.086-.111.086-.239V8.243L7.6,14.372H7.275L4.464,8.243V12.35a.565.565,0,0,0,.157.471L5.75,14.19v.182H2.543V14.19l1.129-1.368a.547.547,0,0,0,.146-.471V7.6a.408.408,0,0,0-.136-.35l-1-1.211V5.857H5.8L8.2,11.143l2.118-5.282s2.229-.045,2.972,0S13.293,6.039,13.293,6.039Z",
    transform: "translate(913 973.75)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/mediumIcon.6713a8849ea21494fc88db3892bb513b.svg";
export { ForwardRef as ReactComponent };